<template>
  <div class="overlay">
    <div class="loading-spinner" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue';

onMounted(() => {
  document.body.classList.add('overlay-open');
});

onBeforeUnmount(() => {
  document.body.classList.remove('overlay-open');
});
</script>

<style lang="scss">

.overlay-open {
  min-height: 100%;
  overflow: hidden;
}

.overlay {
  @include mixins.flex-center($wrap: true);
  background-color: rgba(0, 0, 0, 0.4);
  height: 100%;
  left: 0px;
  pointer-events: auto;
  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 1101;
}
</style>